/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCubes} from '@fortawesome/pro-duotone-svg-icons';

const StackToolIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCubes} {...props} />
);

export default StackToolIcon;
